/* eslint-disable no-useless-escape */

import Config from '@/config.js'
import BlurtClient from '@/mixins/BlurtClient.js'

export default {

  data: function () {
    return {
      chain: {
        blurt_per_vests: 0,
        reward_balance: 0,
        recent_claims: 1,
        blurt_per_rshare: 0,
        gap: 0,
      },

      BLURT_SYMBOL: Config.BLURT,
      VESTS_SYMBOL: Config.VESTS,
      BP_SYMBOL: Config.BP,
    }
  },

  mixins: [
    BlurtClient
  ],

  created() {
    this.getChainProperties()
  },

  methods: {
    // changeFeedPrice(price) {
    // },

    updateRS() {
      this.chain.blurt_per_rshare = this.chain.reward_balance / this.chain.recent_claims;

      this.$store.state.chain.blurt_per_rshare = this.chain.blurt_per_rshare
    },

    async getChainProperties(force = false) {
      if (!force && this.$store.state.chain.blurt_per_vests) {
        this.chain = this.$store.state.chain
        return
      }

      var result = await this.blurt_database_call('get_reward_fund', ['post'])
      this.chain.reward_balance = parseFloat(result.reward_balance)
      this.chain.recent_claims = parseInt(result.recent_claims)

      this.$store.state.chain.reward_balance = this.chain.reward_balance
      this.$store.state.chain.recent_claims = this.chain.recent_claims
      this.updateRS();

      result = await this.blurt_database_call('get_dynamic_global_properties');
      for (var i in result) this.chain[i] = result[i]
      this.chain.blurt_per_vests = parseFloat(result.total_vesting_fund_blurt) / parseFloat(result.total_vesting_shares)

      this.$store.state.chain.blurt_per_vests = this.chain.blurt_per_vests

      this.chain.gap = this.chain.reward_balance / this.chain.recent_claims * 2 * 2e12

      let properties = await this.blurt_database_call('get_chain_properties');
      console.log(properties)
      this.chain.operation_flat_fee = properties.operation_flat_fee;
      this.chain.bandwidth_kbytes_fee = properties.bandwidth_kbytes_fee;
      this.chain.account_creation_fee = properties.account_creation_fee;
      this.chain.proposal_fee = properties.proposal_fee;

      this.$store.state.chain.operation_flat_fee = this.chain.operation_flat_fee;
      this.$store.state.chain.bandwidth_kbytes_fee = this.chain.bandwidth_kbytes_fee;
      this.$store.state.chain.account_creation_fee = this.chain.account_creation_fee;
      this.$store.state.chain.proposal_fee = this.chain.proposal_fee;
      this.updateRS();
    },

    vests2bpFloat(vests) {
      return Math.round(parseFloat(vests) * this.chain.blurt_per_vests * 1000) / 1000;
    },

    vests2bpString(vests) {
      return (parseFloat(vests) * this.chain.blurt_per_vests).toFixed(3) + ' ' + Config.BP;
    },
    witnessVotes2bp(votes) {
      votes = parseInt(votes)
      var bp = (parseInt(votes) / 1e6 ) * this.chain.blurt_per_vests
      if (bp < 1e3) return `${bp.toFixed(2)} ${Config.BP}`
      if (bp < 1e6) return `${(bp / 1e3).toFixed(2)}k ${Config.BP}`
      if (bp < 1e9) return `${(bp / 1e6).toFixed(2)} million ${Config.BP}`
      if (bp < 1e12) return `${(bp / 1e9).toFixed(2)} billion ${Config.BP}`
    },
    calculateFee(operation) {
      let size = JSON.stringify(operation).replace(/[\[\]\,\"]/g, '')
        .length;
      let operationFlatFee = parseFloat(this.$store.state.chain.operation_flat_fee );
      let bw_fee = Math.max(
        0.001,
        ((size / 1024) * parseFloat(this.$store.state.chain.bandwidth_kbytes_fee)).toFixed(3)
      );
      return (operationFlatFee + bw_fee).toFixed(3)+ ' ' + Config.BLURT;
    }
  }
}
